module.exports = __webpack_public_path__ + "img/certificate_bg2_new.07b79ec1.jpg";